import * as React from 'react';

import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { Coordination } from 'data/models/Coordination';

import {
    CoordinationCardDetailsActionsTab as ActionsTab,
    CancelCoordinationAction,
    ChangeProviderAction
} from './actions';

export const CoordinationCardDetailsActionsTabView = SuperCritical(({ model: m } : { model : ActionsTab }) =>
    <div className="coordinationcarddetailsactionstab">
        <CoordinationActions model={m} />
        <CoordinationDescriptionView coordination={m.CoordinationCard.Coordination} />
    </div>
);

const CoordinationActions = SuperCritical(({ model: m } : { model : ActionsTab }) =>
    <div className="ccard-details-actions-tab__section ccard-details-actions-tab__coordination-actions-shell">
        <div className="ccard-details-actions-tab__section-title">Coordination Actions</div>
        {m.HasAnyAvailableActions() ?
            <div>
                <CancelCoordinationActionView action={m.CancelCoordination} />
                <ChangeProviderActionView action={m.ChangeProvider} />
            </div> :
            <div className="no-actions-available">
                There are no actions available.
            </div>
        }
    </div>
);

const CancelCoordinationActionView = SuperCritical(({ action } : { action : CancelCoordinationAction }) =>
    action.IsAvailable() ?
        <div className="ccard-details-actions-tab__coordination-action cancel-coordination-action">
            <div className="coordination-action-link-shell">
                <a
                    href=""
                    className="coordination-action-link"
                    onClick={noDefault(() => action.IsSelected(true))}
                >
                    Cancel this Coordination
                </a>
            </div>
            {action.IsSelected() ?
                <div className="pc-confirm">
                    <span className="pc-confirm-question">
                        <b>Are you sure?</b> The provider will be notified.
                    </span>
                    <button
                        className="pc-confirm-button pc-confirm-button-primary"
                        onClick={action.Perform}
                        disabled={action.IsPerforming()}
                    >
                        Yup
                    </button>
                    <button
                        className="pc-confirm-button"
                        onClick={() => action.IsSelected(false)}
                        disabled={action.IsPerforming()}
                    >
                        Nope
                    </button>
                </div> :
                <div className="coordination-action-description">
                    Turn off coordination for this milestone. The current provider will be notified and the
                    coordination will be reset to "Inactive."
                </div>
            }
        </div> :
        null
);

const ChangeProviderActionView = SuperCritical(({ action } : { action : ChangeProviderAction }) =>
    action.AvailableProviders().length > 0 ?
        <div className="ccard-details-actions-tab__coordination-action change-provider-action">
            <div className="coordination-action-link-shell">
                <a
                    href=""
                    className="coordination-action-link"
                    onClick={noDefault(() => action.IsSelected(true))}
                >
                    Change Provider
                </a>
                {action.IsSelected() &&
                    <select
                        className="provider-dropdown"
                        value={action.Draft.ProviderId()}
                        onChange={e => action.Draft.ProviderId(+e.currentTarget.value)}
                    >
                        {action.AvailableProviders().map(p =>
                            <option value={p.ProviderId()} key={p.ProviderId()}>{p.Provider()?.Name()}</option>
                        )}
                    </select>
                }
            </div>
            {action.IsSelected() ?
                <div className="pc-confirm">
                    <span className="pc-confirm-question">
                        <b>Are you sure?</b> Both providers will be notified.
                    </span>
                    <button
                        className="pc-confirm-button pc-confirm-button-primary"
                        onClick={action.Perform}
                        disabled={action.IsPerforming()}
                    >
                        Yup
                    </button>
                    <button
                        className="pc-confirm-button"
                        onClick={() => action.IsSelected(false)}
                        disabled={action.IsPerforming()}
                    >
                        Nope
                    </button>
                </div> :
                <div className="coordination-action-description">
                    Change the organization responsible for this coordination. This will set the status to
                    pending (yellow) and notify both organizations of the change.
                </div>
            }
        </div> :
        null
);

// UI fragments for consumption here and by the cancelled C-Card details view.
export const CoordinationDescriptionView = SuperCritical(({ coordination } : { coordination : () => Coordination | null }) =>
    <div className="ccard-details-actions-tab__section ccard-details-actions-tab__coordination-description-shell">
        <div className="ccard-details-actions-tab__section-title">Coordination Description</div>
        <div className="coordination-description">
            {coordination()?.Description()}
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/actionsview.tsx